export default __webpack_public_path__ + "static/media/phone.8825cd5c.svg";